// removed by extract-text-webpack-plugin
module.exports = {"notFoundWrapper":"_3jHCJInB5hdV-MARhfrffC","content":"_1o-HYelvqmPNojMNfhd4FB","formSearch":"_3tV-li68shvDdXalplJPp1","icon":"xgefTgfBSM1002Rjj9fSR"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/NotFoundPage/NotFoundPage.scss
// module id = 1849
// module chunks = 0